import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useSlice } from "components/hooks/useSlice";
import { Link } from "react-router-dom";

import { useContext } from "react";
import { PopoverContext } from "./PopoverContext";

export function NoItems({ service }) {
  const { close } = useContext(PopoverContext);
  const { hasGoogleAccessToken, officialBmailAddress } = useSlice("myStatus");

  if (hasGoogleAccessToken) {
    return (
      <NoItemsWrapper>
        No items available for your{" "}
        <a href={`http://b${service}.berkeley.edu`}>b{service} account</a>
      </NoItemsWrapper>
    );
  }

  if (officialBmailAddress) {
    return (
      <NoItemsWrapper>
        To display your bConnected activity,{" "}
        <Link to="settings" onClick={close}>
          connect your bConnected
        </Link>{" "}
        account to CalCentral.
      </NoItemsWrapper>
    );
  }

  return (
    <NoItemsWrapper>
      <div>Your bConnected account is being established.</div>
      <p>
        Please wait up to 24 hours after creating your CalNet ID for your
        bConnected account to establish. If still unavailable after 24 hours
        visit{" "}
        <a href="https://mybconnected.berkeley.edu/my/account/index">
          mybConnected
        </a>
        .
      </p>
    </NoItemsWrapper>
  );
}

NoItems.propTypes = {
  service: PropTypes.oneOf(["Mail", "Cal", "Drive"]),
};

const NoItemsWrapper = styled.div`
  padding: var(--md);
  background: var(--white);
`;
